<template>
    <div class="order-reference-view-wrapper">
        <div v-if="isLoading" class="loading">
            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true">
            </SpeenComponent>
        </div>
        <template v-else>
            <ErrorOverlay v-if="errorMessage" :title="'Orden No Disponible'" :message="errorMessage" :fontScale="0.75">
            </ErrorOverlay>
            <OrderInfo :staticOrderInfo.sync="staticOrderInfo" :dynamicOrderInfo.sync="dynamicOrderInfo"></OrderInfo>
            <StationsTable :data="data" class="table station-info--table"></StationsTable>
        </template>

    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ProductionControlModals } from "../../control_produccion/utils";
import StationsTable from "../components/StationsTable";
import OrderInfo from "../components/OrderInfo";
import ErrorOverlay from "../../common/components/ErrorOverlay";
import SpeenComponent from "../../common/components/SpeenComponent";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";

export default {
    name: "order-reference-view",
    components: { ErrorOverlay, OrderInfo, StationsTable, SpeenComponent },
    props: {
        fromModal: Boolean,
        id: Number
    },
    data() {
        return {
            data: null,
            orderReferenceId: null,
            receivingData: false,
            refreshInterval: null,
            isLoading: true,
        }
    },
    mounted() {
        let self = this;
        this.getId()
        this.deleteAllRows();
        self.refreshData()
        self.refreshInterval = setInterval(function () {
            (self.data?.order_state_id === 2 && !self.receivingData) && self.refreshData()
        }, 10000)
    },
    beforeDestroy() {
        let self = this;
        clearInterval(self.refreshInterval)
    },
    methods: {
        ...mapActions('order_reference_view', ['createRow', 'updateRow', 'deleteAllRows']),
        getId() {
            if (this.fromModal) {
                let modal = this.activeModalByModalName(ProductionControlModals.ORDER_REFERENCE_VIEW)
                this.orderReferenceId = modal ? modal.data : null;
            } else if (!isNaN(this.id)) this.orderReferenceId = this.id;
        },
        formatPackagingFormat(format) { // CAJA -> Cajas
            let firstCharacter = format.substring(0, 1);
            let restToLower = format.substring(1, format.length).toLowerCase()

            return firstCharacter + restToLower + 's';
        },
        refreshData() {
            let self = this;
            this.receivingData = true;
            showCustomSuccessSweetAlert('Información actualizada');
            axios.get(`/api/order-reference/computed-data/${self.orderReferenceId}`)
                .then(response => {
                    if (response.data) {
                        self.data = response.data;
                        var i = 0;
                        let tableRows = self.data.table_rows;
                        tableRows.forEach(r => {
                            let rowData = {
                                row: {
                                    index: i,
                                    id: r.id,
                                    key: r.table_key,
                                    parent_key: r.parent_key,
                                    type: r.table_row_type,
                                    data: r,
                                    collapsed: false,
                                }
                            };
                            self.rowByKey(r.table_key)
                                ? self.updateRow(rowData)
                                : self.createRow(rowData);
                            i++;
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    self.isLoading = false;
                    self.receivingData = false;
                });
        },
        isOrderReferenceFinished(orderStateId) {
            return orderStateId === 3;
        },
    },
    computed: {
        ...mapGetters('production_control', ['activeModals', 'activeModalByModalName', 'orderReferenceById']),
        ...mapGetters('order_reference_view', ['rows', 'rowByKey']),
        staticOrderInfo() {
            return {
                reference: this.data.reference_descrip ? this.data.reference_descrip : 'Referencia No Definida',
                client: this.data.client_name ? this.data.client_name : 'Cliente No Definido',
                batch: this.data.batch ? this.data.batch : 'Lote No Definido',
                startDate: this.data.start_date ? this.data.start_date : 'Fecha de inicio no definida',
                idealEndDate: this.data.ideal_end_date ? this.data.ideal_end_date : 'Fecha de fin ideal no definida',
                realEndDate: this.data.end_date ? this.data.end_date : 'Fecha de fin no definida',
                grossWeight: (this.data.reference_gross_weight
                    ? Number(this.data.reference_gross_weight).toLocaleString('es-ES', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ''
                    : '0,000') + ' KG/Caja',
                name: this.data.descrip ? this.data.descrip : 'Nombre de Orden No Definido',
                production_line_name: this.data.production_line_name ? this.data.production_line_name : 'LINEA PRODUCCION XX',
                productionLineDefaultPackagingFormat: this.data.packaging_format_descrip ? this.formatPackagingFormat(this.data.packaging_format_descrip) : 'Sin Formato',
                workedTime: this.data ? this.data.worked_time : 0,
                isOrderReferenceFinished: this.isOrderReferenceFinished(this.data.order_state_id),
            }
        },
        dynamicOrderInfo() {
            let dataExists = this.data && !this.error;
            return {
                completedPercentage: dataExists ? Utils.round(this.data.completed_percentage, 1) : 0,
                completedPercentageBars: dataExists ? this.data.completed_percentages_by_shift : [],
                barPercentageMax: dataExists ? this.data.bar_percentage_max : 0,
                lostPercentage: dataExists ? Utils.round(this.data.lost_percentage, 1) : 0,
                okQuantity: dataExists ? Utils.round(this.data.ok_quantity) : 0,
                objectiveQuantity: dataExists ? Utils.round(this.data.total_quantity) : 0,
                delayedQuantity: dataExists ? Utils.round(this.data.delayed_quantity, 1) : 0,
                quality: dataExists ? Utils.round(this.data.quality, 1) : 0,
                lostTime: dataExists ? this.data.lost_time : 0,
                productionCoefficient: dataExists ? Utils.round(this.data.production_coefficient, 1) : 0,
                theoreticalProductionCoefficient: dataExists ? Utils.round(this.data.theoretical_production_coefficient, 1) : 0,
                theoreticalEndDate: this.data.theoretical_end_date ? this.data.theoretical_end_date : 'Finalizacion Teorica ND',
                realEndDate: this.data.end_date ? this.data.end_date : 'Orden no finalizada',
                isFinished: this.data.order_state_id == 3,
                productionLineDefaultPackagingFormat: dataExists ? this.data.packaging_format_descrip : 'No Format',
                accumulatedWeight: dataExists ? this.data.accumulated_weight.toFixed(2).replace('.', ',') : 0,
                accumulatedWeightInBoxes: dataExists ? Math.floor(this.data.accumulated_weight_in_boxes) : 0,
                excessWeight: dataExists ? this.data.excess_weight.toFixed(2).replace('.', ',') : 0,
                excessWeightInBoxes: dataExists ? Math.floor(this.data.excess_weight_in_boxes) : 0,
            }
        },
        error() {
            return this.data && this.data.hasOwnProperty('error') ? this.data.error : null
        },
        errorMessage() {
            return this.error ? this.error.msg : null
        }
    }
}
</script>

<style lang="scss">
.order-reference-view-wrapper {
    position: relative;

    @mixin state-label-common {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
    }

    .working {
        @include state-label-common;
        background: #4aa34a;
        color: white;
    }

    .no-data {
        @include state-label-common;
        background-color: rgb(153, 153, 153);
        color: white;
    }

    .micro-stop {
        @include state-label-common;
        background-color: rgb(255, 209, 81);
        color: black;
    }

    .stopped {
        @include state-label-common;
        background-color: rgb(255, 0, 0);
        color: white;
    }

    .fw-title-boldest {
        font-weight: 900 !important;
    }

    .bad-quality {
        background: #E74B3C !important;
        color: white;
    }

    .warning-quality {
        background: #FFD700 !important;
        color: black;
    }

    .good-quality {
        background: #77DD77 !important;
        color: black;
    }

    .box--center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .order-info {
        display: flex;

        &>div {
            flex: 1;
            margin: 0.5rem 0;

            &:first-child {
                margin-right: 0.5rem;
            }

            &:last-child {
                margin: 0 0 0.5rem 0.5rem;
            }

        }

        .static-data {
            .static-data--card {
                &-header {
                    .title {
                        font-size: 1.1rem;
                        float: left;
                    }

                    .production-line-name {
                        float: right;
                        font-size: 1.3rem;
                        font-weight: 300;
                        color: white;
                    }
                }

                &-body {
                    display: flex;
                    flex-wrap: wrap;
                    height: max-content;

                    &>div {
                        white-space: nowrap;
                        width: 50%;
                        padding: 1rem;

                        &>div:first-child {
                            font-size: 1.1rem;
                            font-weight: 500;
                        }

                        &>div:last-child {
                            font-size: 0.85rem;
                            font-weight: 400;
                        }
                    }
                }
            }

            .extra-buttons {
                margin: 0.5rem 0 0 0;
                font-size: 1.2rem;

            }
        }

        .dynamic-data {
            position: relative;

            .completed-percentage {
                width: 100%;

                //margin: 0.5rem;
                &--text {
                    margin: 0.5rem 0;

                    * {
                        display: inline;
                        //white-space: nowrap;
                    }

                    .completed-quantity {
                        float: right;
                    }
                }

                &--bar-wrapper {
                    border: 1px solid lightgray;
                    height: 1.5rem;
                    position: relative;
                    display: flex;

                    .completed-percentage-bar {
                        height: 100%;
                        width: 80%;
                    }
                }
            }

            &--data-squares {
                display: flex;
                flex-wrap: wrap;
                width: 100%;

                .data-square {
                    $dataSquareClass: &;
                    width: calc(50% - 1rem);
                    background: #EEEEEE;
                    margin: 0.5rem;
                    padding: 0.75rem;
                    display: flex;

                    &>div {
                        width: 50%;

                        * {
                            white-space: nowrap;
                        }
                    }

                    &--text {
                        .text--title {
                            font-size: 1.2rem;
                            font-weight: 500;
                            display: flex;
                            gap: 0.5rem;
                        }

                        .text--subtitle {
                            font-size: 0.8rem;
                            display: flex;
                            gap: 0.25rem;
                            margin-top: 0.3rem;
                        }
                    }

                    &--data {
                        text-align: right;

                        .data--main {
                            font-size: 1.4rem;
                            font-weight: 500;
                        }

                        .data--secondary {
                            font-size: 0.9rem;
                        }
                    }
                }

                .delayed-quantity {
                    background: #E74B3C;
                    color: white;
                }
            }
        }

    }
}
</style>
